import './LoadingScreen.scss'
import CircularProgress from '@material-ui/core/CircularProgress'
import React from 'react'

export const LoadingScreen = () => (
  <div className="loadScreen">
    <CircularProgress style={{ color: '#b1ff44' }} />
  </div>
)
